import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from "../../_components/Toast";
import { accountService } from '../../_services';

function AddEdit({ history, match, parentUser, onClose }) {
    const { id } = match && match.params?match.params:{id:null};
    const isAddMode = !id;
    
    const initialValues = {
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        role: 'Admin',
        password: '',
        confirmPassword: '',
        parentUser:parentUser||""
    };

    const validationSchema = Yup.object().shape({
       /* title: Yup.string()
            .required('Title is required'),*/
        firstName: Yup.string()
            .required('First Name is required'),
        lastName: Yup.string()
            .required('Last Name is required'),
        email: Yup.string()
            .email('Email is invalid')
            .required('Email is required'),
        // role: Yup.string()
        //     .required('Role is required'),
        password: Yup.string()
            .concat(isAddMode ? Yup.string().required('Password is required') : null)
            .min(6, 'Password must be at least 6 characters'),
        confirmPassword: Yup.string()
            .when('password', (password, schema) => {
                if (password) return schema.required('Confirm Password is required');
            })
            .oneOf([Yup.ref('password')], 'Passwords must match')
    });

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        if (isAddMode) {
            createUser(fields, setSubmitting);
        } else {
            updateUser(id, fields, setSubmitting);
        }
           if (typeof onClose === 'function') {
      console.log("Calling parent onClose function");
      onClose();
    }
    }

    function createUser(fields, setSubmitting) {
        accountService.create(fields)
            .then(() => {
                toast.success('User added successfully', { keepAfterRouteChange: true });
                onClose?onClose():history.push('.');
            })
            .catch(error => {
                setSubmitting(false);
                toast.error(error);
            });
    }

    function updateUser(id, fields, setSubmitting) {
        accountService.update(id, fields)
            .then(() => {
                toast.success('Update successful', { keepAfterRouteChange: true });
                onClose?onClose():history.push('.');
            })
            .catch(error => {
                setSubmitting(false);
                toast.error(error);
            });
    }

    return (
        <Formik style={{padding:"10px", textAlign:"center"}} initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting, setFieldValue }) => {
                useEffect(() => {
                    if (!isAddMode) {
                        // get user and set form fields
                        accountService.getById(id).then(user => {
                            const fields = ['title', 'firstName', 'lastName', 'email', 'role'];
                            fields.forEach(field => setFieldValue(field, user[field], false));
                        });
                    }
                }, []);

                return (
                    <Form style={{padding:"20px", maxWidth:"500px"}}>
                        <div className="form-row" >
                        
                            <div className="form-group col-5">
                                <label>First Name</label>
                                <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} />
                                <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group col-5">
                                <label>Last Name</label>
                                <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} />
                                <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-7">
                                <label>Email</label>
                                <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                                <ErrorMessage name="email" component="div" className="invalid-feedback" />
                            </div>
                            {false && <div className="form-group col">
                                <label>Role</label>
                                <Field name="role" as="select" className={'form-control' + (errors.role && touched.role ? ' is-invalid' : '')}>
                                    <option value="Admin">Admin</option>
                                </Field>
                                <ErrorMessage name="role" component="div" className="invalid-feedback" />
                            </div>}
                        </div>
                        {!isAddMode &&
                            <div>
                                <h3 className="pt-3">Change Password</h3>
                                <p>Leave blank to keep the same password</p>
                            </div>
                        }
                        <div className="form-row">
                            <div className="form-group col">
                                <label>Password</label>
                                <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                <ErrorMessage name="password" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group col">
                                <label>Confirm Password</label>
                                <Field name="confirmPassword" type="password" className={'form-control' + (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')} />
                                <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-group" style={{float:"right"}}>
                         {onClose?  <button
                  id="memberModalCancelBtn"
                  type="button"
                  className="btn btn-cancel"
                  onClick={() => {
                      onClose();
                  }}
                  style={{marginRight:"10px"}}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>:<Link
                    to={`/admin/users`}
                    className="btn btn-shadow"
                    style={{fontWeight:"bold", marginRight:"20px"}}
                  >
                   Cancel
                  </Link>}
                            <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                Save
                            </button>
                           
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
}

export { AddEdit };